import React, { useState, useEffect } from "react";
const miro = window.miro;
var layoutSingle = require("image-layout/layouts/single");
var layoutFixedPartition = require("image-layout/layouts/fixed-partition");
var layoutFixedColumns = require("image-layout/layouts/fixed-columns");

export default function ImageTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  const [sliderValue, setSliderValue] = useState(0);
  const [miroUserSelection, setMiroUserSelection] = useState([]);
  const [singleImageSelected, setSingleImageSelected] = useState(false);
  const [onlyImagesSelected, setOnlyImagesSelected] = useState(false);
  const [miroBoardState, setMiroBoardState] = useState([]);
  const [miroViewport, setMiroViewport] = useState({
    height: null,
    width: null,
    x: null,
    y: null,
  });

  useEffect(() => {
  }, [sliderValue]);

  async function getSelection() {
    // get set selection
    // get viewport
    const miroViewport = await miro.board.viewport.get();
    setMiroViewport(miroViewport);

    const miroSelection = await miro.board.getSelection();
    setMiroUserSelection(miroSelection);

    const miroBoardState = await miro.board.get();
    setMiroBoardState(miroBoardState);

    if (miroSelection.length === 1 && miroSelection[0].type === "image") {
      setSingleImageSelected(true);
    } else {
      setSingleImageSelected(false);
    }

    if (miroSelection.every(isImage)) {
      setOnlyImagesSelected(true);
    } else {
      setOnlyImagesSelected(false);
    }
  }

  function isImage(item) {
    let result;
    item.type === "image" ? (result = true) : (result = false);
    return result;
  }

  function updateSlider(e) {
    let value = e.target.value;
    setSliderValue(value);
  }

  async function scaleSelection() {
    if (onlyImagesSelected) {
      miroUserSelection.forEach((image) => {
        image.rotation = +sliderValue;
        image.sync();
      });
    }
  }

  return (
    <div className="grid">
      <div className="cs1 ce12">MVP for this tool arriving soon.</div>
      {/* <div className="cs1 ce12">
        <div className="cs1 ce12" style={{ marginBottom: "32px" }}></div>
        <div className="grid" style={{ marginBottom: "24px" }}>
          <div className="cs1 ce7">
            <div className="p-large">1 Image Selected?</div>
          </div>
          <div className="cs8 ce12">
            <div className="p-large">{singleImageSelected ? "YES" : "NO"}</div>
          </div>
          <div className="cs1 ce7">
            <div className="p-large">Only Images Selected?</div>
          </div>
          <div className="cs8 ce12">
            <div className="p-large">{onlyImagesSelected ? "YES" : "NO"}</div>
          </div>
          <div className="cs1 ce12"></div>
          <button
            type="button"
            className="button button-primary button-small cs1 ce12"
            onClick={getSelection}>
            Get Selection
          </button>
        </div>

        <div className="h3">Rotate Images: {sliderValue}°</div>
        <div className="slidecontainer">
          <input
            type="range"
            min="-180"
            max="180"
            value={sliderValue}
            className="slider"
            onChange={(e) => {
              updateSlider(e);
            }}
            onMouseUp={scaleSelection}
            id="myRange"
          />
        </div>
      </div> */}
    </div>
  );
}
